import React, { useState } from 'react';
import TabComponent from '../../components/TabComponent';
import InvestmentTableIndex from './InvestmentTable';
import InvestmentIndex from './Investment';
import BranchTransferIndex from './BranchTransfer';
import BranchTransferTableIndex from './BranchTransferTable';
import SuspenseTransactionsIndex from './SuspenseTransactions';

export const InvestmentFormIndex = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const tabOptions = [
    {
      to: '',
      label: 'Investment Form',
      index: 0,
    },
    {
      to: '',
      label: 'Investment Table',
      index: 1,
    },
    {
      to: '',
      label: 'Branch Transfer Form',
      index: 2,
    },
    {
      to: '',
      label: 'Branch Transfer Table',
      index: 3,
    },
    {
      to: '',
      label: 'Suspense Transactions',
      index: 4,
    },
  ];

  return (
    <div className="transactions__page">
      <h3>Investment</h3>
      <div className="">
        <TabComponent
          taboptions={tabOptions}
          selectedTab={selectedIndex}
          setSelectedTab={setSelectedIndex}
        />
      </div>
      <div className="main__container">
        {selectedIndex === 1 && <InvestmentTableIndex />}
        {selectedIndex === 0 && <InvestmentIndex />}
        {selectedIndex === 2 && <BranchTransferIndex />}
        {selectedIndex === 3 && <BranchTransferTableIndex />}
        {selectedIndex === 4 && <SuspenseTransactionsIndex />}
      </div>
    </div>
  );
};
